import detectCardType from '../validation/detectCardType';

export const getCardTypeWithPrefix = (cardNumber) => {
  if (cardNumber && cardNumber.length > 0) {
    return detectCardType(cardNumber)?.iconName;
  }
  return '';
}
